import { render, staticRenderFns } from "./ordini.vue?vue&type=template&id=d12f48fa&"
import script from "./ordini.vue?vue&type=script&lang=js&"
export * from "./ordini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports